<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">

				<FormItem label="广告投放商" prop="advSponsorId" class="sj">
					<Select v-model="formValidate.advSponsorId" filterable placeholder="请选择广告投放商"  @on-change="onChange">
						<Option v-for="sonsor in sonsors" :key="sonsor.id" :value="sonsor.id">{{sonsor.companyName}}</Option>
					</Select>
				</FormItem>
				<FormItem label="投放素材" prop="advSponsorMaterialId" class="sj">
					<Select v-model="formValidate.list[0].advSponsorMaterialId" filterable placeholder="请选择广告投放商">
						<Option v-for="materia in materias" :key="materia.id" :value="materia.id">{{materia.remark}}</Option>
					</Select>
				</FormItem>
				<FormItem label="投放设备" prop="mac" class="sj">
					<Select v-model="formValidate.list[0].allianceMacs" multiple filterable placeholder="请选择投放设备">
						<Option v-for="mac in macs" :key="mac.id" :value="mac.id">{{mac.machineCode}}</Option>
					</Select>
				</FormItem>
				<FormItem label="开始时间" prop="beginDateTime" class="sj">
					<DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="formValidate.list[0].beginDateTime"></DatePicker>
				</FormItem>
				<FormItem label="结束时间" prop="overDateTime" class="sj">
					<DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="formValidate.list[0].overDateTime"></DatePicker>
				</FormItem>

				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					id:'',
					advSponsorId: '',
					list: [{
						beginDateTime: '',
						overDateTime: '',
						advSponsorMaterialId: '',
						allianceMacs: []
					}]
				},
				sonsors: [], //广告投放商
				materias: [], //素材
				macs: [], //设备
				ruleValidate: {
					/* advSponsorId: [{
						required: true,
						message: '广告投放商不能为空！！！',
						trigger: 'blur'
					}],
					advSponsorMaterialId: [{
						required: true,
						message: '投放素材不能为空！！！',
						trigger: 'blur'
					}],
					mac: [{
						required: true,
						message: '投放设备不能为空！！！',
						trigger: 'blur'
					}], 
					beginDateTime: [{
						required: true,
						message: '开始时间不能为空！！！',
						trigger: 'blur'
					}],
					overDateTime: [{
						required: true,
						message: '结束时间不能为空！！！',
						trigger: 'blur'
					}] */

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						this.$http.post(http.url+'/adv/order/update', this.formValidate).then(res => {
							let data = res.data
							switch (data.code) {
								case 200:
									this.$Message.success('新增成功!');
									break;

								case 1000:
									this.$Message.error('登陆失效，请重新登陆!');
									setTimeout(function() {
										this.$router.push('/login')
									}, 1000);
									break;
								case 100:
									this.$Message.error('服务器异常!');
									break;
								case 101:
									this.$Message.error(data.error);
									break;
								default:
									this.$Message.error('服务器异常!');
									break;
							}

						}, res => {
							this.$Message.error('系统异常请刷新后重试!');
						})

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			onChange() {
				this.pageMeaterial()
			},
			pageSonsor() { //查询广告投放商
				this.$http.post(http.url+'/adv/sponsor/page', {
					page: 0,
					size: 1000
				}).then(res => {
					let data = res.data
					switch (data.code) {
						case 200:
							console.log(data)
							this.sonsors = data.page.content
							this.pageMeaterial()
							break;

						case 1000:
							this.$Message.error('登陆失效，请重新登陆!');
							setTimeout(function() {
								this.$router.push('/login')
							}, 1000);
							break;
						case 100:
							this.$Message.error('服务器异常!');
							break;
						case 101:
							this.$Message.error(data.error);
							break;
						default:
							this.$Message.error('服务器异常!');
							break;
					}

				}, res => {
					this.$Message.error('系统异常请刷新后重试!');
				})
			},
			pageMeaterial() {//查询素材
				console.log(this.formValidate.advSponsorId)
				if (this.formValidate.advSponsorId == "") {
					return;
				}
				this.$http.post(http.url+'/adv/sponsor/meaterial/page', {
					page: 0,
					size: 1000,
					spomsorId: this.formValidate.advSponsorId
				}).then(res => {
					let data = res.data
					switch (data.code) {
						case 200:
							this.materias = data.page.content
							break;

						case 1000:
							this.$Message.error('登陆失效，请重新登陆!');
							setTimeout(function() {
								this.$router.push('/login')
							}, 1000);
							break;
						case 100:
							this.$Message.error('服务器异常!');
							break;
						case 101:
							this.$Message.error(data.error);
							break;
						default:
							this.$Message.error('服务器异常!');
							break;
					}

				}, res => {
					this.$Message.error('系统异常请刷新后重试!');
				})
			},
			pageMac() {//查询设备
				this.$http.post(http.url+'/adv/order/mac/page', {
					page: 0,
					size: 1000
				}).then(res => {
					let data = res.data
					switch (data.code) {
						case 200:
							this.macs = data.macs.content
							break;
			
						case 1000:
							this.$Message.error('登陆失效，请重新登陆!');
							setTimeout(function() {
								this.$router.push('/login')
							}, 1000);
							break;
						case 100:
							this.$Message.error('服务器异常!');
							break;
						case 101:
							this.$Message.error(data.error);
							break;
						default:
							this.$Message.error('服务器异常!');
							break;
					}
			
				}, res => {
					this.$Message.error('系统异常请刷新后重试!');
				})
			},
			get() {//查询订单信息
				this.$http.post(http.url+'/adv/order/findById', {
					id:this.formValidate.id
				}).then(res => {
					let data = res.data
					switch (data.code) {
						case 200:
							this.formValidate = data.advOrder
							break;
			
						case 1000:
							this.$Message.error('登陆失效，请重新登陆!');
							setTimeout(function() {
								this.$router.push('/login')
							}, 1000);
							break;
						case 100:
							this.$Message.error('服务器异常!');
							break;
						case 101:
							this.$Message.error(data.error);
							break;
						default:
							this.$Message.error('服务器异常!');
							break;
					}
			
				}, res => {
					this.$Message.error('系统异常请刷新后重试!');
				})
			}
		},
		created() {
			let t = this
			let id=t.$route.query.id
			t.formValidate.id=id
			t.get()
			t.pageSonsor()
			t.pageMac()
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/adv/order/update.vue